<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			<div class="modal__head">
				<div class="modal__head__title">Water</div>
				<div class="modal__head__subtitle">Recommended as default by RICS guidance note. </div>
			</div>
			<div class="modal__content">
				<ul>
					<div class="col md-6">
						<li>Bodies of water (ponds, lakes, reservoirs - top and nearside bottom where possible)</li>
						<li>Bottom of banks</li>
						<li>Flood defence structures</li>
						<li>Flood/lock gates</li>
						<li>Flood/harbour/sea/retaining walls</li>
						<li>Fountains</li>
						<li>Gabions</li>
						<li>Groynes/sea defences</li>
					</div>
					<div class="col md-6">
						<li>Piers, jetties, walkways, gantries, landing stages, bridges</li>
						<li>Pipes/outfalls/culverts (Minimum diameter pipe to be surveyed 0.1 m</li>
						<li>Sheet piling</li>
						<li>Shore line (detail exposed at low tide)</li>
						<li>Top of banks</li>
						<li>Watercourses (drains, ditches, streams, rivers)</li>
						<li>Waterfalls</li>
						<li>Water level</li>
						<li>Weirs and Locks</li>
					</div>
				</ul>
				<div class="clearfix"></div>
				<button class="primary" @click="closeModaler">Close</button>
			</div>
		</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'WaterModal',
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/WaterModal.vue